import React, { createContext, useContext, useMemo, useState } from 'react';

const TableSorting = createContext(null);

export const useSort = () => useContext(TableSorting);

export const ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const SortProvider = ({ children, onSortChange }) => {
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const handleSortChange = (newKey) => {
    let key = newKey;
    let order = ORDER.ASC;

    // Rotate asc-desc-none or set asc for new key
    if (sortOrder === ORDER.ASC) {
      order = sortKey === newKey ? ORDER.DESC : ORDER.ASC;
    } else if (sortKey === newKey) {
      key = null;
      order = null;
    }

    setSortKey(key);
    setSortOrder(order);

    onSortChange?.({ key, order });
  };

  const value = useMemo(
    () => ({ sortKey, sortOrder, onSortChange: handleSortChange }),
    [sortKey, sortOrder],
  );

  return (<TableSorting.Provider data-testid="TableSorting-Provider-e4c4e567" value={value}>{children}</TableSorting.Provider>);
};
